import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useApi } from '../../api/useApi'

// Antd
import { InfoCircleOutlined } from '@ant-design/icons'
import { Button, Form, Select, Switch, Typography } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { getHandlaggare, getRoles, getTeam } from '../../store/organizationSlice'
import { useUpdateTenantUserDefaults } from './hooks/updateTenantUserDefaults'
import { useTenantUserDefaults } from './hooks/tenantUserDefaults'

const { Option } = Select

type Props = {}

const UserDefaults = (props: Props) => {
  const dispatch = useDispatch()
  const navigate = useHistory()
  const api = useApi()

  // Redux state
  const anvandarState = useSelector(getHandlaggare)
  const teams = useSelector(getTeam)
  const roles = useSelector(getRoles)

  const { mutateAsync: updateTenanteUserDefaults, isLoading } = useUpdateTenantUserDefaults()
  const { data: defaults } = useTenantUserDefaults()

  const [form] = useForm()
  useEffect(() => {
    if (anvandarState && anvandarState.length === 0) {
      // setAnvandare(api, dispatch)
    }
  }, [anvandarState, api, dispatch])

  useEffect(() => {
    if (defaults) {
      console.log('defaults', defaults)
      form.setFieldsValue({
        roleName: defaults.roleName,
        team: defaults.team,
        scopes: defaults.scopes,
        active: defaults.active,
        inStructure: defaults.inStructure,
      })
    }
  }, [defaults, form])

  const onFinish = async (values: any) => {
    console.log(values)

    updateTenanteUserDefaults({
      active: values.active ?? true,
      inStructure: values.inStructure ?? true,
      ...values,
    })
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <>
      <Typography.Text>Här väljer du vilka standardinställningar som ska användas när en användare skapas automatiskt via SAML</Typography.Text>
      <Form
        form={form}
        name="user-defaults"
        style={{ marginTop: '1rem' }}
        initialValues={{
          roleName: defaults?.roleName,
          team: defaults?.team,
          scopes: defaults?.scopes,
          active: defaults?.active,
          inStructure: defaults?.inStructure,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <div className="input-wrapper-flex">
          <Form.Item
            label="Roll"
            name="roleName"
            tooltip={{ title: 'Användarens roll styr vilka vyer som hen har tillgång till.', icon: <InfoCircleOutlined /> }}
            rules={[
              {
                required: true,
                message: 'Vänligen välj en roll',
              },
            ]}
          >
            <Select placeholder={''} className="select">
              {roles.map((item: { role_name: string; permissions: string[]; modules: string[] }) => {
                return (
                  <Option value={item.role_name} key={item.role_name}>
                    {item.role_name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Team"
            name="team"
            tooltip={{ title: 'Användarens team styr vilket team som användaren tillhör.', icon: <InfoCircleOutlined /> }}
            rules={[
              {
                required: true,
                message: 'Vänligen välj ett team',
              },
            ]}
          >
            <Select placeholder={''} className="select">
              {teams.map((item: { team_id: number; team_namn: string; avdelning: number }) => {
                return (
                  <Option value={item.team_id} key={item.team_id}>
                    {item.team_namn}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Behörighet"
            name="scopes"
            tooltip={{ title: 'Användarens behörighet styr vilka team och därmed vilka handläggare och ärenden som användaren har tillgång till.', icon: <InfoCircleOutlined /> }}
            rules={[
              {
                required: true,
                message: 'Vänligen välj behörigheter',
              },
            ]}
          >
            <Select mode="multiple" placeholder={''} className="select">
              {teams.map((item: { team_id: number; team_namn: string; avdelning: number }) => {
                return (
                  <Option value={item.team_id} key={item.team_id}>
                    {item.team_namn}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
        </div>
        <div className="flex flex-row items-center gap-8">
          <Form.Item
            label="Status"
            name="active"
            tooltip={{
              title: 'Justera om användarens status ska vara aktiv eller inaktiv. Om användaren är aktiv kan hen logga in i Pejlen.',
              icon: <InfoCircleOutlined />,
            }}
          >
            <Switch defaultChecked={true} />
          </Form.Item>
          <Form.Item
            label="I struktur"
            name="inStructure"
            tooltip={{
              title: 'Justera om användaren ska vara i strukturen eller inte genom att klicka på knappen. Om användaren är med i strukturen, visas hens ärenden under vyn Ärendefördelning.',
              icon: <InfoCircleOutlined />,
            }}
          >
            <Switch defaultChecked={true} />
          </Form.Item>
          <Button type="primary" htmlType="submit" style={{ marginLeft: 'auto' }}>
            Spara
          </Button>
        </div>
      </Form>
    </>
  )
}

export default UserDefaults
